import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import withSizes from 'react-sizes'
import { Card, Input, Progress, Row, Col } from 'antd';
import DropDown from '../../Components/DropDown/index';
import { TiThMenu } from 'react-icons/ti';
import { MdSearch } from 'react-icons/md';
import { FaAngleLeft } from 'react-icons/fa';
import CustomLink from './components/link';
import { AppContext } from '../../Contexts/App/AppContext';
import service from '../../Contexts/App/AppService';
import '../../assets/styles/global.scss'
import './styles/nav.scss';
import { browserNames } from '../../utils/helper';

const useStyles = makeStyles(theme => ({
    selectEmpty: {
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        marginTop: theme.spacing(2),
        background: '#fff'
    },
}));

function NavBar(props) {
    const classes = useStyles();

    const history = useHistory();
    const { location } = history;
    const appCtx = useContext(AppContext)
    const { projects, selectedProjectId } = appCtx;

    const [locations, setLocations] = useState([]);
    const [selectedId, setSelected] = useState(false);
    const [Links, setLinks] = useState([]);

    const [selectedLocation, setSelectedLocation] = useState(-1);
    const [selectedProj, setSelectedProj] = useState(null)

    const { navValues, setNavValues } = props;

    useEffect(() => {
        const tempProj = projects.filter(proj => (proj.project_id === selectedProjectId))
        if (tempProj.length > 0) {
            setSelectedProj(tempProj[0])
        }
    }, [selectedProjectId])

    useEffect(() => {
        setSelectedLocation(appCtx.selectedLocationId);
        setLinks(setActiveNav);
        history.listen(onRouteChange);

    }, []);

    useEffect(() => {
        setLinks(setActiveNav);
    }, [projects]);

    useEffect(() => {
        setLocations(appCtx.userDetails.locations);
    }, [appCtx.userDetails]);

    useEffect(() => {
        setSelectedLocation(appCtx.selectedLocationId);
        setLinks(setActiveNav());
    }, [appCtx.selectedLocationId]);
    function onRouteChange() {
        setLinks(setActiveNav());
    }



    useEffect(() => {
        // console.log("location.pathname >",location.pathname);
        setLinks(setActiveNav());
    }, [location.pathname]);


    const onChange = type => {
        if (type === 'logout') {
            service.SetUserLogOut(appCtx, res => {
                localStorage.removeItem('LocationID');
                localStorage.removeItem('ParentID');
                localStorage.removeItem('ProjectID');
                localStorage.removeItem('subActivity');
                localStorage.removeItem('parking-lot-filter-orderItems');
                localStorage.removeItem('filter-orderItems');
                history.push('/login');
            });
        }
        const changedLinks = Links.map(curr => {
            const link = curr;
            if (link.type === type) {
                link.selected = true;
            } else {
                link.selected = false;
            }
            return link;
        });

        setLinks(changedLinks);
    };

    function setActiveNav() {
        const navLinks = [
            {
                type: 'parkingLot',
                selected: location.pathname.includes('parkinglot'),
                redirect: '/parkinglot'
            },
            {
                type: 'inventory',
                selected: location.pathname === '/' || location.pathname.includes('itemdetails'),
                redirect: '/'
            },
            {
                type: 'return',
                selected: false,
                selected: location.pathname.includes('returns'),
                redirect: '/returns'
            },
            // {
            //     type: 'support',
            //     selected: false,
            //     redirect: '/'
            // },
            {
                type: 'setting',
                selected: location.pathname.includes('settings'),
                redirect: '/settings'
            },
            {
                type: 'logout',
                selected: false,
            },
        ];
        const navLinksDefault = [
            {
                type: 'inventory',
                selected: location.pathname === '/' || location.pathname.includes('itemdetails'),
                redirect: '/'
            },
            {
                type: 'return',
                selected: false,
                selected: location.pathname.includes('returns'),
                redirect: '/returns'
            },
            {
                type: 'parkingLot',
                selected: location.pathname.includes('parkinglot'),
                redirect: '/parkinglot'
            },
            // {
            //     type: 'support',
            //     selected: false,
            //     redirect: '/'
            // },
            {
                type: 'setting',
                selected: location.pathname.includes('settings'),
                redirect: '/settings'
            },
            {
                type: 'logout',
                selected: false,
            },
        ];
        if (projects.length > 1)
            return navLinks;
        else
            return navLinksDefault;
    }
    const getPath = (id) => {
        let URL = '/';
        if (location.pathname.includes('itemdetails')) URL = "/";
        else if (location.pathname.includes('parkinglot')) URL = `/parkinglot/${id}`;
        else if (location.pathname.includes('returns')) URL = "/returns";
        else URL = '/';
        return URL;
    }

    const setLocation = id => {
        service.SetSelectedLocation(appCtx, id);
        history.push(getPath(id));
    }

    const handleChange = id => {
        service.SetProjectLocation(appCtx, id)
        history.push(getPath(appCtx.selectedLocationId));
    }

    const data = locations ? locations.map(obj => {
        return { value: obj.location_id, label: obj.name }
    }) : [];

    const locationProjects = projects && projects.length > 0 ? projects.map(obj => {
        return { value: obj.project_id, label: obj.project_name }
    }) : [];
    // const data = projects ? projects.map(obj => {
    //     return { value: obj.location_id, label: obj.name }
    // }) : [];
    const getUserMenuDefault = () => {
        return (
            <div>
                {Links.slice(0, 3).map((nav, index) => {
                    let re_direct = nav.redirect;
                    if (nav.type === "parkingLot") re_direct = `${re_direct}/${selectedLocation}`
                    return (
                        <div key={index} onClick={() => { history.push(re_direct) }}><CustomLink type={nav.type} selected={nav.selected}
                            onSelectionChange={onChange}
                        /></div>);
                })}
            </div>
        )
    }
    const getUserMenu = () => {
        return (
            <div>
                {Links.slice(0, 1).map((nav, index) => {
                    let re_direct = nav.redirect;
                    if (nav.type === "parkingLot") re_direct = `${re_direct}/${selectedLocation}`
                    return (
                        <div key={index} onClick={() => { history.push(re_direct) }}><CustomLink type={nav.type} selected={nav.selected}
                            onSelectionChange={onChange}
                        /></div>);
                })}
                <div className="projects p-l-10 m-t-15">Projects</div>
                <div className="p-l-10 m-b-10">
                    {locationProjects.length > 0 ? <DropDown Data={locationProjects} selectedId={selectedProjectId} setLocation={handleChange} view="Nav" /> :
                        <div className={`card-dropdown-empty ${classes.selectEmpty}`}>
                            <MenuItem className="option" >
                                <div className="building-empty">{'No Projects Available'}</div>
                            </MenuItem>

                        </div>
                    }
                </div>
                {Links.slice(1, 3).map((nav, index) => {
                    let re_direct = nav.redirect;
                    if (nav.type === "parkingLot") re_direct = `${re_direct}/${selectedLocation}`
                    return (
                        <div key={index} onClick={() => { history.push(re_direct) }}>
                            <CustomLink
                                type={nav.type}
                                selected={nav.selected}
                                onSelectionChange={onChange}
                            /></div>);
                })}
            </div>
        )
    }
    const getSideBarMenuTop = () => {
        if (locationProjects.length > 1) {
            return getUserMenu();
        }
        else {
            return getUserMenuDefault();
        }
    }
    const getTopTitle = () => {
        if (!appCtx.loading)
            switch (appCtx.userRole) {
                case 'isp':
                    return 'ISP';
                    break;
                case 'nbo':
                    return 'Building';
                    break;
                default:
                    return 'Building';
                    break;
            }
        else return '';
    }
    return (
        <>
            <div >
                <div className="flex-space-inbetween p-10 p-b-0">
                    <div className="buildings m-t-10">{getTopTitle()}</div>
                    <div className="p-t-15">
                        {navValues && navValues.view === "mobile" && <FaAngleLeft className="nav-icon-close" onClick={() => {
                            let temp = navValues;
                            temp.showNav = !temp.showNav;
                            temp.view = props.isMobileOrTab ? "mobile" : "web";
                            setNavValues(temp);
                        }} />}
                    </div>
                </div>
                <>
                    <div className="p-10 p-t-0 p-b-3">
                        <DropDown
                            Data={data}
                            selectedId={selectedLocation}
                            setLocation={setLocation}
                            view="Nav"
                        />
                    </div>
                    <div className="nav-content"
                        style={{
                            height: browserNames.includes('Chrome') ? 'calc(100vh - 90px)' : 'calc(100vh - 220px)',
                        }}>
                        {getSideBarMenuTop()}
                        <div className="white-bar">
                            {Links.slice(3, Links.length).map((nav, index) => <div key={index} onClick={() => { history.push(nav.redirect) }}>
                                <CustomLink
                                    type={nav.type}
                                    selected={nav.selected}
                                    redirect={nav.redirect}
                                    onSelectionChange={onChange}
                                /></div>)}
                        </div>
                    </div>
                </>
            </div>
        </>
    );
}

const mapSizesToProps = ({ width }) => ({
    isMobileOrTab: width < 780,
})

export default withSizes(mapSizesToProps)(NavBar)